<template>
  <div>
    <div class="mb-3 text-md-right text-center">
      <div class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
           style="width: 160px;">
        <button @click="gotoAddCategory" class="btn btn-primary mr-2 mb-4 float-right">+ Add Category</button>
      </div>
    </div>


    <div class="table-responsive">
      <table class="table table-striped table-style-1">
        <thead>
        <tr>
          <th scope="col">Sr.no</th>
          <th
              scope="col"
              class="sorting"
          >{{ $lang.messages.name }}
          </th>
          <th
              scope="col"
              class="sorting"
          >{{ $lang.messages.sobat_catalog_price }}
          </th>
          <th
              scope="col"
              class="sorting"
          >Age restriction
          </th>
          <th
              scope="col"
              class="sorting"
          >{{ $lang.messages.sobat_catalog_description }}
          </th>
          <th scope="col" class="text-center">{{ $lang.messages.action }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(c, i) in categories" :key="c.id">
          <td>{{ i + 1 }}</td>
          <td>{{ c.name }}</td>
          <td>{{ c.sobat_catalog_price }}</td>
          <td>{{ c.age_restriction }}</td>
          <td><div v-html="c.sobat_catalog_description"></div></td>
          <td class="text-center">
            <a
                href="javascript:void(0)"
                @click="gotoEditCategory(c.id)"
                class="text-primary mr-2 font-18"
            >
              <i class="mdi mdi-pencil font-20"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>

    </div>


  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Alert from '@/components/Alert'
import draggable from "vuedraggable"
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import {VueEditor} from "vue2-editor";

export default {
  data() {
    return {
      categories: []
    }
  },

  props: {
    mobileSetting: {
      type: Boolean
    }
  },

  components: {
    Pagination,
    Alert,
    VueEditor,
  },

  computed: {},

  methods: {
    getCategory() {
      this.$api
          .getAPI({
            _action: '/sobat/category'
          })
          .then(async res => {
            this.categories = res.results
          });
    },
    gotoAddCategory(e) {
      this.$router.push('/add-sobat-category');
    },
    gotoEditCategory(id) {
      this.$router.push('/edit-sobat-category/' + id);
      this.$shareService.setMapValue('tab', 'stores-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab2-link');
    },

  },

  async created() {
    this.getCategory()
  },

}
</script>
